import AuthResponse from "interfaces/response/AuthResponse";
import { getValue, setValue } from "./StorageUtility";

const localStorageKey = "portalUserAuthInfo";

export const saveAuthInfoToStorage = (authInfo: AuthResponse) => {
  setValue(localStorageKey, JSON.stringify(authInfo));
};

export const getAuthInfoFromStorage = () => {
  const authData = getValue(localStorageKey);
  if (authData) {
    return JSON.parse(authData) as AuthResponse;
  }
  return null;
};
